import React, { Suspense } from 'react';
import { Flex } from 'glints-aries/es';
import { Badge, Icon, Typography } from 'glints-aries/es/@next';
import { Neutral } from 'glints-aries/es/@next/utilities/colors';
import { space2, space4 } from 'glints-aries/es/@next/utilities/spacing';
import { FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { GlintsLogoRed } from '../../../common/color';
import useGetFeatureCount from '../../../common/hooks/useGetFeatureCount';
import useIsMonthlyQuotaEnabled from '../../../common/hooks/useIsMonthlyQuotaEnabled';
import ErrorBoundaryWithCrashReporting from '../../../components/Error/ErrorBoundaryWithCrashReporting';
import { useGetCompanyCreditInventorySuspenseQuery } from '../hooks/useGetCompanyCreditInventory';

const StyledBadge = styled(Badge)`
  padding: ${space2} ${space4};
  background-color: ${Neutral.B99};
`;

function CompanyShortlistQuotaSegment() {
  const { companyShortlistQuota } = useGetFeatureCount();
  const isUnlimited = Boolean(companyShortlistQuota?.isUnlimited);
  const totalRemaining = companyShortlistQuota?.totalRemaining ?? 0;
  return (
    <>
      <Typography variant="overline">·</Typography>
      <img
        src="/images/contact-packs/contact-pack-icon.svg"
        alt=""
        width={12}
        height={12}
        style={{
          marginRight: space2,
        }}
      />
      <Typography variant="overline">
        <Choose>
          <When condition={isUnlimited}>∞</When>
          <Otherwise>
            <FormattedNumber value={totalRemaining} />
          </Otherwise>
        </Choose>
      </Typography>
    </>
  );
}

function CreditBalanceActivatorBadgeComponent() {
  const { data } = useGetCompanyCreditInventorySuspenseQuery('cache-first');
  const isMonthlyQuotaEnabled = useIsMonthlyQuotaEnabled();
  const amount = data.totalAmount;
  return (
    <StyledBadge>
      <Flex
        style={{
          gap: space2,
        }}
        alignItems="center"
      >
        <Icon name="ri-glints-logo-fill" fill={GlintsLogoRed} width={12} />
        <Typography variant="overline">
          <FormattedNumber value={amount} />
        </Typography>
        {isMonthlyQuotaEnabled && <CompanyShortlistQuotaSegment />}
      </Flex>
    </StyledBadge>
  );
}

export default function CreditBalanceActivatorBadge() {
  return (
    <ErrorBoundaryWithCrashReporting fallback={null}>
      <Suspense fallback={null}>
        <CreditBalanceActivatorBadgeComponent />
      </Suspense>
    </ErrorBoundaryWithCrashReporting>
  );
}
